import React from "react";
import { CometCanvas } from "./CometCanvas";

export function SectionEnd() {
  return (
    <>
    <div className="sectionend">
      <CometCanvas />
      <div className="rocketimg"></div>
      <div className="thanks">Thanks for reading !</div>
    </div>
    <div className="contact">
      <a href="https://www.linkedin.com/in/monalussa/">Contact me</a>
    </div>
    </>
  );
}
